import axios from 'axios';
import { geo } from './endpoints';

const getHeaders = () => {
  return {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
};

const client = axios.create({
  baseURL: process.env.RAZZLE_API_GEO,
  ...getHeaders(),
});

export default {
  getCities() {
    return client.get(geo.getCities);
  },
  getLocalities() {
    return client.get(geo.getLocalities);
  },
};
